<mat-card>
    <mat-card-content>

        <div class="content" fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-md="45%">
                <app-mat-auto-search [isEditable]="true" [displayField]="'request_number'" [setSearchValue]="false"
                                     [masterDashboard]="true" [name]="'request_number'"
                                     placeholder="Search by Request number"
                                     [(ngModel)]="request" (ngModelChange)="onRequestSelection($event)" [idField]="null"
                                     [labelItemTemplate]="requestSelectedItem" [itemTemplate]="requestItem"
                                     [listUrl]="request_url+'?search=::search::'">
                </app-mat-auto-search>
                <div>
                    <mat-card-title>
                        <h1>
                            <span id="title1">OPS</span><span id="title2"> Date Change </span>
                        </h1>

                    </mat-card-title>
                    <div class="content-desc">
                        <p>Now, you can add, view and manage and update all the details</p>
                        <p>Simply search and select <b>Booking</b> to manage the data.</p>
                    </div>
                    <div id="btnapart">
                        <button id="bt2" mat-stroked-button (click)="addNewRequest()">Add New</button>
                        <button id="bt1" mat-raised-button routerLink="/ops-date-change/list">View All</button>
                    
                    </div>
                </div>
            </div>
            <div class="cardimg" fxFlex="100" fxFlex.gt-md="55%">
                <!-- <img src="assets/images/backgrounds/Request_one_way.jpg" alt=""> -->
                <i class="flaticon-close" *ngIf="Tutorial" (click)="showTutorial()"></i>
                <div class="window" [class.theatre]="Tutorial">
                    <div class="slider" [class.slide]="Tutorial">
                        <!-- <img src="assets/images/backgrounds/Charge.jpg" alt=""> -->
                        <i class="flaticon-play-button" *ngIf="!Tutorial" (click)="showTutorial()"></i>
                        <logzy-img-loader [src]="'assets/images/backgrounds/Request_one_way.jpg'"></logzy-img-loader>
                        <div class="youtube">
                            <iframe *ngIf="play" src="https://www.youtube.com/embed/o2RfyGcRVcI?autoplay=1"
                                    title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen width="565" height="320"></iframe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="features" fxFlex="100" fxFlex.gt-md="100%">
                <div class="featureHead">
                    <div class="featureTitle"><span>Features</span></div>
                    <div class="featureDescription"><span>Know what makes the One way Request simple and unique.</span>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayoutAlign="space-around center">
                    <div class="feature">
                        <mat-icon class="icon">auto_graph</mat-icon>
                        <span>Revenue</span>
                    </div>
                    <div class="feature">
                        <mat-icon class="icon">pie_chart</mat-icon>
                        <span>Analytics</span>
                    </div>
                    <div class="feature">
                        <mat-icon class="icon">inventory_2</mat-icon>
                        <span>Management</span>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #requestItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="requestListShow">
        <span class="requestNumber fs-13">
            {{ item?.request_number }}
            ({{ item?.request_type?.name }} | {{
                item?.request_type?.dev_name == 'buy_sell' ? item?.transaction_type ==
                'use'
                    ? 'Buy' : 'Sell' : item?.transaction_type == 'use' ? 'Use' : 'Supply'
            }} {{ item?.requirement[0]?.quantity }}*{{ item?.requirement[0]?.container_size_type?.display }})
            <ng-container *ngIf="item?.requirement.length>1">+ {{ item?.requirement.length - 1 }} More</ng-container>
        </span>
        <span class="companyName">
            {{ item?.requirement[0]?.quantity }}*{{ item?.requirement[0]?.container_size_type?.display }}
            ({{ item?.requirement[0]?.condition?.value }})<br>
            <span>{{ item?.transaction_type == 'use' ? 'Customer' : 'Supplier' }}</span>:
            {{ item?.company ?? '-' }}
        </span>
    </div>
</ng-template>

<ng-template #requestSelectedItem let-item>
    {{ item?.request_number }}
</ng-template>
